import { createReducer } from 'reduxsauce';
import { Types } from './action';

const INITIAL_STATE = {
  loading: false,
  error: null,
  localeStrings: [],
  availableLanguages: [],
  userLanguagePreference: '',
  langauageLabel: [],
  message: ''
};

const getLocaleStringsStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const getLocaleStringsSuccess = (state = INITIAL_STATE, action) => {
  const { localeStrings } = action.payload;

  return {
    ...state,
    localeStrings,
    loading: false
  };
};

const getLocaleStringsFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error,
    loading: false
  };
};

const getAvailableLanguagesStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const getAvailableLanguagesSuccess = (state = INITIAL_STATE, action) => {
  const { availableLanguages } = action.payload;

  return {
    ...state,
    availableLanguages,
    loading: false
  };
};

const getAvailableLanguagesFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error,
    loading: false
  };
};

const getUserLanguagePreferenceStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const getUserLanguagePreferenceSuccess = (state = INITIAL_STATE, action) => {
  const { userLanguagePreference } = action.payload;

  return {
    ...state,
    userLanguagePreference,
    loading: false
  };
};

const getUserLanguagePreferenceFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error,
    loading: false
  };
};

const getLanguageLabelStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const getLanguageLabelSuccess = (state = INITIAL_STATE, action) => {
  const { langauageLabel } = action.payload;

  return {
    ...state,
    langauageLabel
  };
};

const getLanguageLabelFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error
  };
};

const updateUserLanguagePreferenceStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const updateUserLanguagePreferenceSuccess = (state = INITIAL_STATE, action) => {
  const { message } = action.payload;

  return {
    ...state,
    message,
    loading: false
  };
};

const updateUserLanguagePreferenceFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error,
    loading: false
  };
};

const addUpdateLanguageLabelTextStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const addUpdateLanguageLabelTextSuccess = (state = INITIAL_STATE, action) =>
  // const { langauageLabel } = action.payload;
  ({
    ...state,
    // langauageLabel,
    loading: false,
    message: action?.payload?.message
  });
const addUpdateLanguageLabelTextFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error,
    loading: false
  };
};

const clearSuccessMessage = (state = INITIAL_STATE, action) => ({
  ...state,
  message: action.payload
});

const syncLanguageLabelsStart = (state = INITIAL_STATE) => ({
  ...state,
  loading: true
});

const syncLanguageLabelsSuccess = (state = INITIAL_STATE, action) =>
  // const { langauageLabel } = action.payload;
  ({
    ...state,
    // langauageLabel,
    loading: false
  });
const syncLanguageLabelsFail = (state = INITIAL_STATE, action) => {
  const { error } = action.payload;

  return {
    ...state,
    error,
    loading: false
  };
};

const HANDLERS = {
  [Types.GET_LOCALE_STRINGS_START]: getLocaleStringsStart,
  [Types.GET_LOCALE_STRINGS_SUCCESS]: getLocaleStringsSuccess,
  [Types.GET_LOCALE_STRINGS_FAIL]: getLocaleStringsFail,
  [Types.GET_AVAILABLE_LANGUAGES_START]: getAvailableLanguagesStart,
  [Types.GET_AVAILABLE_LANGUAGES_SUCCESS]: getAvailableLanguagesSuccess,
  [Types.GET_AVAILABLE_LANGUAGES_FAIL]: getAvailableLanguagesFail,
  [Types.GET_USER_LANGUAGE_PREFERENCE_START]: getUserLanguagePreferenceStart,
  [Types.GET_USER_LANGUAGE_PREFERENCE_SUCCESS]:
    getUserLanguagePreferenceSuccess,
  [Types.GET_USER_LANGUAGE_PREFERENCE_FAIL]: getUserLanguagePreferenceFail,
  [Types.GET_LANGUAGE_LABEL_START]: getLanguageLabelStart,
  [Types.GET_LANGUAGE_LABEL_SUCCESS]: getLanguageLabelSuccess,
  [Types.GET_LANGUAGE_LABEL_FAIL]: getLanguageLabelFail,
  [Types.UPDATE_USER_LANGUAGE_PREFERENCE_START]:
    updateUserLanguagePreferenceStart,
  [Types.UPDATE_USER_LANGUAGE_PREFERENCE_SUCCESS]:
    updateUserLanguagePreferenceSuccess,
  [Types.UPDATE_USER_LANGUAGE_PREFERENCE_FAIL]:
    updateUserLanguagePreferenceFail,
  [Types.ADD_UPDATE_LANGUAGE_LABEL_TEXT_START]: addUpdateLanguageLabelTextStart,
  [Types.ADD_UPDATE_LANGUAGE_LABEL_TEXT_SUCCESS]:
    addUpdateLanguageLabelTextSuccess,
  [Types.ADD_UPDATE_LANGUAGE_LABEL_TEXT_FAIL]: addUpdateLanguageLabelTextFail,
  [Types.CLEAR_SUCCESS_MESSAGE]: clearSuccessMessage,

  [Types.SYNC_LANGUAGE_LABELS_START]: syncLanguageLabelsStart,
  [Types.SYNC_LANGUAGE_LABELS_SUCCESS]: syncLanguageLabelsSuccess,
  [Types.SYNC_LANGUAGE_LABELS_FAIL]: syncLanguageLabelsFail
};

export const localeStringsReducer = createReducer(INITIAL_STATE, HANDLERS);
